import { AuthState, initialAuthState } from './auth.state';
import { AuthAction, AuthActionType, AuthConfig } from './auth.action';
import { AccountInfo as MsalUser } from '@azure/msal-browser';

export function authReducer(
  state: AuthState = initialAuthState,
  action: AuthAction): AuthState {
  switch (action.type) {

    case AuthActionType.AuthConfig:
      return {
          ...state,
          ...((action as AuthConfig).payload)
      };

    case AuthActionType.AuthLoginSuccess:
      return {
        ...state,
        loggedIn: true,
        // userInfo: MsalUser
      };

      case AuthActionType.AuthLoginFailure:
        return {
          ...state,
          loggedIn: false,
          userInfo: null
        };

    default:
      return state;
  }
}
